<template>
      <a-col>
          <div>
            <a-list v-show="!pointsInfo.length"><a-empty description="沒有任何資料" /></a-list>
            <a-list v-show="pointsInfo.length" item-layout="horizontal" :split="true" :data-source="pointsInfo" class="points_list_container">
                <a-list-item slot="renderItem" slot-scope="item,index" @click="handleSelectedPoint(index)">
                    <div class="list_serial_num">
                        <span>{{(index + 1) >= 10 ? index + 1 : `0${index + 1}`}}</span>
                    </div>
                    <div class="list_content">
                        <span>
                            <img src="../../assets/icons/map_clock_icon.svg" alt="" class="clock_icon">
                            {{$moment(item.time).format('HH:mm:ss') || '--'}}
                        </span>
                        <span>
                          <img src="../../assets/icons/detail_car_status.svg" alt="">{{speed(item)}} km/h
                        </span>
                        <span>
                            <img src="../../assets/icons/mileage.svg" alt="" class="mileage_icon">{{totalMileage(item)}}km
                        </span>
                        <span>
                            <img src="../../assets/icons/map_location_icon.svg" alt="" class="location_icon">{{item.gps.longitude || '--'}}, {{item.gps.latitude || '--'}}
                        </span>
                    </div>
                </a-list-item>
            </a-list>
          </div>
      </a-col>
</template>

<script>
    import { mapState } from 'vuex';

    export default {
        name: 'IndividualPointsList',
        data() {
            return {
                pointsInfo: [],
                isTbox: false,
            }
        },
        mounted() {
            this.pointsInfo = this.scheduleDetailDataList || [];
            this.isTbox = this.scheduleDetailProductName === 'STMB-4000';
        },
        methods: {
            handleSelectedPoint(index) {
                sessionStorage.setItem('selectPointIndex', index);
                this.$router.go(-1);
            },
            speed(item){
              const { gps, can } = item;
              const speed = (this.isTbox)? gps?.speed : can?.canSpeed;
              return (speed !== undefined)? speed : '--';
            },
          totalMileage(item){
            const { gps, can } = item;
            const total = (this.isTbox)? gps?.gpsAccumulatedMileage : can?.totalMileage;
            return (total !== undefined)? total : '--';
          }
        },
        computed: {
            ...mapState('scheduleDetailData', ['scheduleDetailDataList']),
            ...mapState('scheduleDetailData', ['scheduleDetailProductName']),
        },
    }
</script>

<style lang="scss" scoped>
    .points_list_container {
        padding: 0 12px;
        top: 53px;
        .ant-list-item {
            justify-content: flex-start;
            padding: 15px 0;
            align-items: stretch;
            &:first-child {
                padding-top: 0;
            }
            .list_serial_num {
                flex-basis: 10%;
                span {
                    display: flex;
                    justify-content: center;
                    align-items: center;
                    color: rgba(52, 55, 65, 0.6);
                    font-weight: 500;
                    font-size: 16px;
                    line-height: 24px;
                    // padding: 0 15px 0 4px;
                }
            }
            .list_content {
                flex-basis: 88%;
                display: flex;
                flex-wrap: wrap;
                span {
                    color: #343741;
                    line-height: 24px;
                    &:nth-child(odd) {
                        flex-basis: 37%;
                        display: flex;
                        align-items: center;
                    }
                    &:nth-child(even) {
                        flex-basis: 63%;
                    }
                    &:first-child, &:nth-child(2) {
                        margin-bottom: 6px;
                    }
                    img {
                        margin-right: 12px;
                        margin-left: 5px;
                    }
                    .clock_icon {
                        width: 16px;
                    }
                    .mileage_icon {
                        width: 17px;
                    }
                    .location_icon{
                        width: 14px;
                        margin-left: 6px;
                    }
                }
            }
        }
    }
    @media (max-width: 320px) {
        .points_list_container {
            .ant-list-item {
                .list_content {
                    flex-basis: 87%;
                    span {
                        font-size: 12px;
                    }
                }
            }
        }
    }
</style>
